import { Link } from 'react-router-dom';

interface PlaceholderPageProps {
  title: string;
  icon?: string;
  description?: string;
}

export default function PlaceholderPage({
  title,
  icon = 'ri-tools-line',
  description = 'This page is currently under construction. Check back soon!',
}: PlaceholderPageProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-cyan-50 flex flex-col items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        {/* Icon */}
        <div className="w-24 h-24 bg-cyan-100 rounded-full flex items-center justify-center mx-auto mb-8 shadow-md">
          <i className={`${icon} text-cyan-600 text-4xl`}></i>
        </div>

        {/* Badge */}
        <span className="inline-flex items-center gap-1.5 bg-cyan-500 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4 tracking-wide uppercase">
          <i className="ri-time-line text-sm"></i>
          Coming Soon
        </span>

        {/* Title */}
        <h1 className="text-4xl font-bold text-gray-900 mt-3 mb-4">{title}</h1>

        {/* Description */}
        <p className="text-gray-500 text-base leading-relaxed mb-10">{description}</p>

        {/* Divider */}
        <div className="w-16 h-1 bg-cyan-400 rounded-full mx-auto mb-10"></div>

        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-6 py-3 rounded-lg transition-colors shadow-md whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}
